import { render, staticRenderFns } from "./Single-Quotation-Detail.vue?vue&type=template&id=985ab9be&"
import script from "./Single-Quotation-Detail.vue?vue&type=script&lang=js&"
export * from "./Single-Quotation-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports